export default __webpack_public_path__ + "static/media/img_area_65.40c9e757.svg";